'use strict';

exports.__esModule = true;
exports.default = getComponentName;


/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/utils/getComponentName.js
// module id = 1456
// module chunks = 0